export default {
	methods: {
		rrAdsNew(isRdg) {
			const hpTopics = ['1827', '1667',  '1688', '3645', '3557', '1624', '3641', '1835', '3633', '1822', '4054', '2729', '1633', '1626', '3570', '3629', '3630'];
			const topicId = this?.store?.pagedata?.omniture?.s_topic || '';
			window.rrAdsNew = !hpTopics.includes(topicId);
			if (isRdg) {
				window.rrAdsNew = true;
			}

			if (window.rrAdsNew) {
				window.ads_ignore = window.ads_ignore || {};
				window.ads_ignore['5000'] = true;
				document.body.classList.add('rr-ads-new');
			}

			const hpTopicsRRTestIds = ['1663', '4223'];
			window.hpTopicsRRTest = hpTopicsRRTestIds.includes(topicId);
		},

		updatefirstPage137Ad() {
			const firstPage137Ad = document.querySelector('.ad-container-137');
			if (firstPage137Ad) {
				firstPage137Ad.style.height = '1050px';
			}
		},

		createRRTestadContainers() {
			const articleEle = document.querySelector('.article.medref');
			const rightRailContnr = document.querySelector('div.main-container.main-container-3');
			const articleHeight = articleEle.clientHeight + 42;
			const initlRRHeight = rightRailContnr.clientHeight;
			const avlblRRSpace = articleHeight - initlRRHeight;
			const adContainerHeight121 = 850;
			const adContainerHeight137 = 1050;
			let currentHeight = adContainerHeight121;
			let index;
			let iteration = 0;
			let remainingSpace = avlblRRSpace;

			// Loop through the number of containers
			for (let i = 0; i < avlblRRSpace; i += currentHeight) {
				if (remainingSpace < currentHeight) {
					break;
				}
				index = Math.ceil((iteration + 1) / 2);

				const newDiv = document.createElement('div');
				newDiv.className = 'container';
				newDiv.style.height = `${currentHeight}px`;

				newDiv.id = `ads2-pos-${currentHeight === adContainerHeight121 ? 121 : 137}-rrt-cont${index + 1}`;
				newDiv.className = `ads2-pos-${currentHeight === adContainerHeight121 ? 121 : 137}-rrt`;
				newDiv.dataset.id = index + 1;

				const innerDiv = document.createElement('div');
				innerDiv.id = `ad-pos-${currentHeight === adContainerHeight121 ? 121 : 137}-${index + 1}`;
				innerDiv.className = `module ad ${currentHeight === adContainerHeight121 ? 'ad-121 inner-container-sticky' : 'ad-137'}`;
				newDiv.appendChild(innerDiv);

				// Append the new div to the right rail container
				rightRailContnr.appendChild(newDiv);

				if (currentHeight === adContainerHeight121) {
					currentHeight = adContainerHeight137;
				} else {
					currentHeight = adContainerHeight121;
				}

				iteration += 1;

				remainingSpace -= currentHeight;
			}
		},

		// This method can be used for loading 121 , 137  or 141 ad
		loadAd(id, pos) {
			// Check if the window object and necessary properties exist
			if (window && window.webmd && window.webmd.ads && window.webmd.ads.ads && !window.webmd.ads.ads[id]) {
				let sizes;
				
				// Determine the sizes based on the value of pos
				if (pos === 141) {
					sizes = [[728, 90], [728, 92]];
				} else {
					sizes = [[300, 250], [300, 600]];
				}
		
				// Define and display the ad
				window.webmd.adsConsumer.defineAd({
					id,
					pos,
					sizes,
				});
				window.webmd.adsConsumer.display();
			}
		},
		

		load923Ad(adId) {
			const adTargets = JSON.parse(JSON.stringify(this.store.pagedata.ad.targets));
			window.webmd.adsConsumer.defineAd({
				id: adId,
				pos: '923',
				sizes: [1, 9],
				class: 'ad-923',
				targets: adTargets,
				blockCodes: this.store.pagedata.ad.blockCodes,
				keys: { strnativekey: 'Vjx59uEm8EVWkMyP8f8smvF8' },
			});
			window.webmd.adsConsumer.display();
		},
		checkToRefreshAds(adsObj, pgval, direction) {
			const adIds = Object.keys(adsObj);
			const allAdsExist = adIds.every(adId => window.webmd.ads.ads[adId]);
			if (allAdsExist) {
				window.webmd.ads.setPageTarget('pg', `${pgval + direction}`);
				window.webmd.ads.refresh({ id: adsObj });
			} else {
				setTimeout(() => this.checkToRefreshAds(adsObj, pgval, direction), 300);
			}
		},

		initObserverRRAds(adId) {
			const options = {
				rootMargin: '30px 0px 30px 0px',
			};
			const observer = new IntersectionObserver(
				this.observeIntersection,
				options,
			);

			document.querySelectorAll(adId).forEach((el) => {
				observer.observe(el);
			});
		},

		observeIntersection(entries) {
			entries.forEach((entry) => {
				this.currentY = window && window.scrollY;
				if (entry.isIntersecting) {
					if (this.currentY >= this.previousY) {
						const { id } = entry.target.dataset;
						const adsobj = {};
						const r121AdId = `ad-pos-121-${id}`;
						const r137AdId = `ad-pos-137-${id}`;
						const prevRR137AdId = `ad-pos-137-${id - 1}`;
						
						if (document.getElementById(r121AdId) && !window.webmd.ads.ads[r121AdId] && parseInt(id, 10) > 1) {
							this.loadAd(r121AdId, 121);
						}
						if (document.getElementById(r137AdId) && !window.webmd.ads.ads[r137AdId] && parseInt(id, 10) > 1) {
							this.loadAd(r137AdId, 137);
						}

						if (window.hpTopicsRRTest) {
							const top141AdId = `ad-top-pos-141-${id}`;
							if (document.getElementById(top141AdId) && !window.webmd.ads.ads[top141AdId] && parseInt(id, 10) > 1) {
								this.loadAd(top141AdId, 141);
							}
						}
					
						// eslint-disable-next-line max-len
						if (window?.webmd?.ads?.initialLoadDisabled && parseInt(id, 10) > 1) {
							const isSponsored = this?.store?.pagedata?.omniture?.s_sponsor_program !== '';
							if (!isSponsored && window?.webmd?.ads?.ads && window.webmd.ads.ads[prevRR137AdId]) { 
								window.webmd.ads.destroy([prevRR137AdId]);
							}
							adsobj[r121AdId] = true;
							adsobj[r137AdId] = true;
							if (window.hpTopicsRRTest) {
								const top141AdId = `ad-top-pos-141-${id}`;
								adsobj[top141AdId] = true;
							}
							window.webmd.ads.setPageTarget('pg', id);
							window.webmd.ads.refresh({ id: adsobj });
						}
					} else if (this.currentY < this.previousY) {
						const adsobj = {};
						const { id } = entry.target.dataset;
						const r121AdId = `ad-pos-121-${id}`;
						const r137AdId = `ad-pos-137-${id}`;
						const top141AdId = `ad-top-pos-141-${id}`;
						const prevRR137AdId = `ad-pos-137-${parseInt(id, 10) + 1}`;
						if (window?.webmd?.ads && window.webmd.ads.initialLoadDisabled) {
							const isSponsored = this?.store?.pagedata?.omniture?.s_sponsor_program !== '';
							if (!isSponsored && window?.webmd?.ads?.ads && window.webmd.ads.ads[prevRR137AdId]) { 
								window.webmd.ads.destroy([prevRR137AdId]);
							}
							if (document.getElementById(r137AdId) && !window.webmd.ads.ads[r137AdId]) {
								this.loadAd(r137AdId, 137);
							}
							
							if (window.webmd.ads.ads[r121AdId]) {
								adsobj[r121AdId] = true;
							}
							
							if (window.webmd.ads.ads[r137AdId]) {
								adsobj[r137AdId] = true;
							}

							if (window.hpTopicsRRTest && parseInt(id, 10) > 1 && window.webmd.ads.ads[top141AdId]) {
								adsobj[top141AdId] = true;
							}
							if (parseInt(id, 10) === 1) {
								const centerwellId = 'ad-centerwell-pos-141-1';
								if (window?.webmd?.ads?.ads?.[centerwellId]) {
									adsobj[centerwellId] = true;
								}
							}
							if (Object.keys(adsobj).length > 0) {
								this.checkToRefreshAds(adsobj, id, 'u');
							}
						}
					}
				}
				this.previousY = this.currentY;
			});
		},

	},
};
